import { render, staticRenderFns } from "./ProgressCounter.vue?vue&type=template&id=08f25602&scoped=true&"
import script from "./ProgressCounter.vue?vue&type=script&lang=js&"
export * from "./ProgressCounter.vue?vue&type=script&lang=js&"
import style0 from "./ProgressCounter.vue?vue&type=style&index=0&id=08f25602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f25602",
  null
  
)

export default component.exports